import { Container, Grid, TextField } from '@material-ui/core';
import { CntPagoModel } from 'actions/CntPagoAction';
import { CustomModal } from 'componentes/CustomModal';
import LoadingOrError from 'componentes/LoadAndShow';
import { BotonesEliminarGuardar } from 'componentes/ui/botones';
import { TituloSeccion } from 'componentes/ui/titulos';
import { useLocalization } from 'contexto/localization/useLocalization';
import useBackCheck from 'hooks/useBackCheck';
import useFormState from 'hooks/useFormState';
import React, { useState } from 'react'

export default function ModalCrearEditarPago({
    tipoAccion,
    pagoId,
    open = false,
    onClose = () => { },
    onSave = () => { },
    onDelete = () => { },
}) {
    // Idioma
    const { strings } = useLocalization();
    // Token

    // Estados
    useBackCheck();
    const { entity, setValue } = useFormState(CntPagoModel);
    const [isLoading] = useState(false);
    const [error] = useState(undefined);
    return (
        <CustomModal
            title={tipoAccion === 'crear'
                ? strings.modules.nuevoPago
                : strings.modules.nuevoPago
            }
            open={open}
            onClose={(_, re) => {
                if (re === "backdropClick" || re === "escapeKeyDown") return false;
                return onClose();
            }}
            padding={0}
            fullWidth
            actions={
                <BotonesEliminarGuardar
                    label={strings.modules.guardar}
                    form='form1'
                    isLoading={isLoading}
                    custom={{ eliminar: false }}
                />
            }
        >
            <Container maxWidth="md" justify="center" style={{ padding: 0 }}>
                {(isLoading || error) && (
                    <LoadingOrError
                        esError={error}
                        esLoading={isLoading}
                        mensajeError={error}
                    />
                )}
            </Container>
            {!isLoading && !error && (
                <Grid container>
                    <Grid item xs={12} md={12} container spacing={2} style={{ padding: "15px" }}>
                        <Grid item xs={12} md={12}>
                            <TituloSeccion label={strings.modules.identificacion} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField
                                name="codigo"
                                label={strings.modules.codigo}
                                variant="outlined"
                                fullWidth
                                required
                                size="small"
                                type="number"
                                value={entity.codigo}
                                onChange={setValue}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </CustomModal>
    )
}
